import { BASE_ENDPOINT } from "../../../endpoint";

export const retrieveLoanRepaymentService = async (
	token: string,
	id: string,
	dueDate: string
) => {
	try {
		const encodedDate = encodeURIComponent(dueDate);
		const response = await fetch(
			`${BASE_ENDPOINT}/user/loanmanagement/repayment/${id}?dueDate=${encodedDate}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
			}
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
		}
		return res;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
